module.exports = {"description":"","displayName":"TextBox","methods":[],"props":{"title":{"type":{"name":"string"},"required":false,"description":"Text to show as title.","defaultValue":{"value":"''","computed":false}},"text":{"type":{"name":"string"},"required":false,"description":"Text to show as content.","defaultValue":{"value":"''","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"","defaultValue":{"value":"null","computed":false}}},"filename":"/components/TextBox/TextBox.jsx"}


//////////////////
// WEBPACK FOOTER
// ./src/components/TextBox/map.json
// module id = 1103
// module chunks = 64632704166719